import { AgreementContent } from "./agreement";
import {
  AgreeItem,
  HeaderItem,
  NotifyWrapper,
  TitleItem,
} from "./resturant-notify";
import * as auth from "auth-provider";
import qs from "qs";
import "./customize.css";

export const PayAgreement = () => {
  const linkParam = auth.getLinkParams();

  const restSite =
    window.location.origin +
    `/restaurant?${qs.stringify({
      code: linkParam.code,
    })}`;

  const restOrderSite =
    window.location.origin +
    `/restaurant?${qs.stringify({
      code: linkParam.code,
      dialogFrom: "orderList",
    })}`;

  return (
    <NotifyWrapper style={{ padding: 0 }}>
      <TitleItem>{AgreementContent.title}</TitleItem>
      <div>
        <HeaderItem iIndex={1}>{`Digital Gift Card Agreement`}</HeaderItem>
        <AgreeItem>
          {`Before you click to agree to this "Digital Gift Card Service Agreement", please read carefully and fully understand the terms and conditions. When you read and click to confirm through the online page or choose to accept this agreement in other ways, it means that you have fully read, understand, and accept this Agreement in its entirety and are willing to be bound by it.If you have any questions about the terms of this agreement, you can contact the customer service staff for consultation.`}
        </AgreeItem>
        <AgreeItem>
          {`The relevant services under this agreement are jointly provided to you by the following entities:
        Chowbus Co., Ltd. (hereinafter referred to as "Chowbus" or "Platform") provides you with technical services related to the display and use of recharge pages; the restaurant provides you with fund management services for digital gift cards.`}
        </AgreeItem>
      </div>
      <div>
        <HeaderItem iIndex={2}>{`About The Digital Gift Card`}</HeaderItem>
        <AgreeItem>
          {`The digital gift card issued to you allows you to load a dollar value
          onto the card to pay for goods and services at a specific restaurant.`}
        </AgreeItem>
        <AgreeItem>
          {`The dollar value on your digital gift card is nonrefundable and may
          not be redeemed for cash.`}
        </AgreeItem>
        <AgreeItem>
          {`Your digital gift card is not subject to any activation or maintenance
          fees and has no expiration date.`}
        </AgreeItem>
      </div>
      <div>
        <HeaderItem iIndex={2}>{`Loading Value`}</HeaderItem>
        <AgreeItem className={"notifyContent"}>
          <span>{`Dollar value may be loaded onto the digital gift card by visiting a participating restaurant or visiting `}</span>
          <a href={restSite} target="_blank" rel="noreferrer">
            here.
          </a>
        </AgreeItem>
        <AgreeItem>{`Unless otherwise specified, dollar values are in USD.`}</AgreeItem>
        <AgreeItem className={"notifyContent"}>
          <span>{`The digital gift card may be reloaded by visiting a participating restaurant or visiting `}</span>
          <a href={restSite} target="_blank" rel="noreferrer">
            here.
          </a>
        </AgreeItem>
      </div>
      <div>
        <HeaderItem iIndex={2}>{`Balance`}</HeaderItem>
        <AgreeItem className={"notifyContent"}>
          <span>{`You may check your digital gift card balance on the receipt when it is used for a transaction or any time at `}</span>
          <a href={restOrderSite} target="_blank" rel="noreferrer">
            here.
          </a>
        </AgreeItem>
      </div>
      <div>
        <HeaderItem iIndex={2}>{`Promotions`}</HeaderItem>
        <AgreeItem>{`Restaurants may run digital gift card promotions at their own discretion and are subject to the terms in this Agreement and any additional terms specified in the promotion.`}</AgreeItem>
      </div>
    </NotifyWrapper>
  );
};
